export const colours = {
	WHITE: "#FFFFFF",
	MIDNIGHT_BLUE: "#121252",
	PEACH: "#FFAA98",
	PALE_PEACH: "#FFEBE7",
	WATERMELON: "#FE5751",
	MINT_GREEN: "#EBFCF6",
	GREEN: "#BBEFD9",
	ERROR: "#D21919",
	VALID: "#028757",
	SHADOW: "#000033",
	PEACH_SHADOW: "#EA5D48",
	LIGHT_GREY: "#F6F6F8",
	SOFT_BLUE: "#E8EEF6",
	BORDER: "rgba(18, 18, 82, 0.4)",
	PALE_ALERT_BLUE: "#EFF0F5",
	ALERT_BLUE: "#696b8f",
};

export const getColours = (contentfulColourString) => {
	switch (contentfulColourString) {
		case "Peach":
			return colours.PEACH;
		case "Midnight Blue":
			return colours.MIDNIGHT_BLUE;
		case "Pale Peach":
			return colours.PALE_PEACH;
		case "White":
			return colours.WHITE;
		case "Watermelon":
			return colours.WATERMELON;
		case "Mint Green":
			return colours.MINT_GREEN;
		case "Green":
			return colours.GREEN;
		case "Soft Blue":
			return colours.SOFT_BLUE;
		default:
			return colours.PEACH;
	}
};

export const getThemeColours = (themeColour) => {
	switch (themeColour) {
		case "green":
			return colours.GREEN;
		default:
			return colours.PALE_PEACH;
	}
};

/**
 * Adds opacity to a 7-character hex colour string (i.e. from the brand
 * `colours` object).
 *
 * @param {string} colorValue
 * @param {number} opacity
 * @returns {string}
 */
export const addOpacityToColor = (colorValue, opacity = 1) => {
	const isValidHexColour =
		typeof colorValue === "string" &&
		colorValue.startsWith("#") &&
		colorValue.length === 7;

	if (isValidHexColour) {
		const alphaHex = Math.floor(opacity * 255)
			.toString(16)
			.padStart(2, "0");
		return `${colorValue}${alphaHex}`;
	}

	return colorValue;
};
